<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :navigation-menu="navigationMenu"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <v-list two-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile :key="(index + 2 * 100)">
            <v-list-tile-action>
              <v-icon :color="color">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.value }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.type }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="deleteButton">
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat :color="color" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>

    <v-layout slot="dialog-card-text" row align-center justify-center>
      <v-flex xs12 sm12 md12 lg6>
        <v-form ref="form">
          <v-text-field
            :label="textFieldLabel"
            single-line
            required
            :rules="textFieldRules || []"
            v-model="phoneNumber"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6>
        <v-select
          :items="types"
          :label="selectLabel"
          v-model="phoneType"
        ></v-select>
      </v-flex>
    </v-layout>
    
    <div slot="dialog-card-actions">
      <v-btn
        :color="color"
        flat
        @click.native="closeDialog()"
      >
        {{ cancelButton }}
      </v-btn>
      <v-btn
        :color="color"
        flat
        @click.native="addPhone()"
      >
        {{ confirmButton }}
      </v-btn>

    </div>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>

  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'

  export default {

    name: 'VuetifyPhoneAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm
    },

    props: {
      phones: {
        type: Array,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      textFieldLabel: {
        type: String,
        default: 'Phone',
        required: false
      },
      textFieldRules: {
        type: Array,
        default: null,
        required: false
      },
      selectLabel: {
        type: String,
        default: 'Type',
        required: false
      },
      phoneTypes: {
        type: Array,
        default: null,
        required: false
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: 'Estás a punto de eliminar un área de trabajo',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      deleteButton: {
        type: Boolean,
        default: true,
        required: false
      },
      navigationMenu: {
        type: Boolean,
        default: true,
        required: false
      },
      value: {
        type: Array,
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [
        {
          text: 'Phone'
        },
        {
          text: 'Mobile'
        },
        {
          text: 'Fax'
        }
      ],
      phoneType: null,
      phoneNumber: null
    }),

    watch: {
      phoneTypes: {
        handler: function (newVal, oldVal) {
          this.types = newVal
          this.phoneType = this.types[0]
        },
        deep: true
      },

      phones: {
        handler: function (newVal, oldVal) {
          this.items = newVal
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validate () {
        return this.$refs.form.validate()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deletePhone()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deletePhone () {
        this.items.splice(this.currentIndex, 1)
        this.$emit('on-delete-phone')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openDialog () {
        this.$refs.aggregator.dialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.$refs.aggregator.dialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addPhone () {
        if (this.validate()) {
          this.closeDialog()
          let item = {
            type: this.phoneType.text,
            value: this.phoneNumber
          }
          this.items.push(item)
          this.$refs.form.reset()
          this.$emit('on-add-phone')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/vuetify-phone-aggregator.vue